import React from 'react';
import { TextField, styled } from '@mui/material';
export type AuthTextFieldProps = React.ComponentProps<typeof TextField> & {
  /**
   * Width of the visible input box (matches Figma). Defaults to 455px (login page).
   * Smart Search modal uses 400px in signup mode per Figma.
   */
  inputWidth?: number | string;
};
const AuthTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== 'inputWidth'
})<AuthTextFieldProps>(({
  theme,
  inputWidth
}) => {
  const desktopWidth = typeof inputWidth === 'number' ? `${inputWidth}px` : inputWidth || '455px';
  return {
    width: '100%',
    maxWidth: desktopWidth,
    '& .MuiOutlinedInput-root': {
      borderRadius: '20px',
      backgroundColor: 'white',
      height: '40px',
      width: '100%',
      '& .MuiOutlinedInput-input': {
        padding: '6px 38px',
        fontSize: "var(--type-h3)",
        fontFamily: 'Montserrat, sans-serif',
        color: '#000',
        width: '100%',
        '&::placeholder': {
          color: 'rgba(0, 0, 0, 0.5)',
          opacity: 1,
          textTransform: 'capitalize'
        },
        [theme.breakpoints.down('sm')]: {
          fontSize: "var(--type-h3)",
          padding: '8px 16px'
        }
      },
      '& fieldset': {
        border: 'none'
      },
      '&:hover fieldset': {
        border: 'none'
      },
      '&.Mui-focused fieldset': {
        border: 'none'
      }
    }
  };
});
export default AuthTextField;
